<template>
  <div class="d-flex justify-content-center align-items-center" style="min-height: 60vh;">
    <div class="text-center">
      <b-spinner variant="primary" />
      <p class="mt-1 text-muted">Connecting to support...</p>
    </div>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import api from '@axios'

export default {
  components: { BSpinner },
  async mounted() {
    try {
      const { data } = await api.get('/analytics/userTawk')
      const text = encodeURIComponent(
        `ImeiCheck Support Request\nUser: ${data.username} (#${data.id})\nEmail: ${data.email}\n\nHi, I need help with:`
      )
      window.open(`https://api.whatsapp.com/send/?phone=3530852108011&text=${text}`, '_blank')
    } catch {
      window.open(`https://api.whatsapp.com/send/?phone=3530852108011&text=${encodeURIComponent('Hi, I need help with my ImeiCheck account.')}`, '_blank')
    }
    this.$router.go(-1)
  },
}
</script>
